import axios from 'axios';
export default {
  mounted() {
    let { title, name, list_data_file } = this.$options
    if (title) {
      title = typeof title === 'function' ? title.call(this) : title
      document.title = `おひさまキッチンえほんや - ${title}`
    } else if (list_data_file) {
      let idx;
      switch(name) {
        case "event_archive":
          idx = 4
          break;
        case "campaign_archive":
          idx = 3
          break;
      }
      axios.get(list_data_file)
        .then( response => {
          if (response.status == 200) {
            var data = response.data.split('\n');
            for(var i=1;i<data.length-1;++i){
              var values = data[i].split(',');
              if(values[0] == this.code) {
                document.title = `おひさまキッチンえほんや - ${values[idx]}`
              }
            }
          }
        })
    } 
  }
}



// WEBPACK FOOTER //
// ./src/plugins/dynamic-title.js